import { HorizontalAlignment } from '@thg-commerce/gravity-theme/alignments'
import { BreakpointArray } from '@thg-commerce/gravity-theme'

export type ProductListThemeInterface = {
  header: {
    horizontalAlignment: HorizontalAlignment
  }
  gridGap: number
  attributesInsetSpacing: BreakpointArray<number>
  productListContainerSpacing: BreakpointArray<number>
}

export const DEFAULT_PRODUCT_LIST_WIDGET_THEME: ProductListThemeInterface = {
  header: {
    horizontalAlignment: HorizontalAlignment.LEFT,
  },
  gridGap: 4,
  attributesInsetSpacing: [0],
  productListContainerSpacing: [2, 4],
}
